"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.siteLogoClassNameRegistry = void 0;
const _contracts_1 = require("../../_contracts");
/**
 * Registry that binds the `Site` with the corresponding logotype filename.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.siteLogoClassNameRegistry = {
    [_contracts_1.Site.CyberDefence24]: 'cyber-defence',
    [_contracts_1.Site.Defence24]: 'defence-24',
    [_contracts_1.Site.Defence24COM]: 'defence-24-com',
    [_contracts_1.Site.Defence24MSPO]: 'defence-24-mspo',
    [_contracts_1.Site.Energetyka24]: 'energetyka-24',
    [_contracts_1.Site.InfoSecurity24]: 'info-security-24',
    [_contracts_1.Site.Space24]: 'space-24',
    [_contracts_1.Site.KadeciRP]: 'kadecirp'
};
//# sourceMappingURL=LineHeader.config.js.map